document.addEventListener('DOMContentLoaded', function () {
	var expandableButtons = document.querySelectorAll('.mj-btn__expandable');

	document.addEventListener('click', function (event) {
		if (!event.target.closest('.mj-btn__expandable')) {
			closePanels();
		}
	});


	// Select the filter remove button
	var removeFilterBtn = document.querySelector('#mj-form__filter-remove');

	// Check if the button exists before adding an event listener
	if (removeFilterBtn) {
		removeFilterBtn.addEventListener('click', function (e) {
			e.preventDefault();
			resetFiltersAndSorting();
		});
	}

	expandableButtons.forEach(function (expandableButton) {
		var filterBtn = expandableButton.querySelector('.filter__btn');
		var panel = expandableButton.querySelector('.mj-form__filter-panel');

		if (filterBtn && panel) {
			if (typeof filterBtn.addEventListener === 'function') {
				filterBtn.addEventListener('click', function () {
					var hasSpecialClass = panel.classList.contains('mj-form__filter-events-panel') || panel.classList.contains('mj-form__filter-location-panel');

					closePanels(panel);

					if (!hasSpecialClass) {
						// Toggle the panel for normal cases
						panel.classList.toggle('active');
					} else {
						// For special classes, keep it open
						panel.classList.add('active');
					}
				});
			}
		}
	});

	function closePanels(currentPanel) {
		expandableButtons.forEach(function (expandableButton) {
			var panel = expandableButton.querySelector('.mj-form__filter-panel');
			if (panel && panel !== currentPanel) {
				// Toggle the panel for normal cases
				panel.classList.remove('active');
			}
		});
	}

	document.querySelectorAll('.missjones-widget-filter__input').forEach(function (inputElement) {
		inputElement.addEventListener('keydown', function (event) {
			if (event.key === 'Enter') {
				//closeAllSuggestedLists();
				applyQueryParamsFilter();
			}
		});
	});
});

function closeAllSuggestedLists() {
	document.querySelectorAll('.missjones-widget-filter__suggested-results-container').forEach(function (panel) {
		panel.classList.remove('--opened');
	}
	)
};


function initializeFilter(filterClass, inputClass, panelClass, listClass, removeFilterClass) {
	var expandable = document.querySelector('.mj-btn__expandable.' + filterClass);

	if (expandable && expandable.querySelector('.' + inputClass)) {

		var input = expandable.querySelector('.' + inputClass);
		var panel = expandable.querySelector('.' + panelClass);
		var itemList = panel.querySelector('.' + listClass);
		var removeFilter = expandable.querySelector('.' + removeFilterClass);

		// Hide the remove filter element by default
		if (removeFilter.classList.contains('active')) {
			removeFilter.classList.remove('active');
		}

		// Check if panel is not null before proceeding
		if (panel && itemList && removeFilter) {
			var options = itemList.querySelectorAll('option');

			// Add click event listener to each option
			options.forEach(function (option) {
				option.addEventListener('click', function () {
					removeFilter.classList.add('active');

					// Close the panel only if it was open before
					if (panel.classList.contains('active')) {
						panel.classList.remove('active');

						// Clear the input value first
						input.value = '';

						// Update the input value with the selected option
						input.value = option.textContent;
					}
				});
			});

			var isActive = false; // Variable to track panel state
			var isInputClicked = false; // Variable to track input click state

			input.addEventListener('input', function () {
				isInputClicked = false;
				const searchTerm = input.value.toLowerCase();
				const removeFilter = input.nextElementSibling;

				options.forEach(function (option) {
					const optionText = option.textContent.toLowerCase();

					if (optionText.includes(searchTerm)) {
						const highlightedText = optionText.replace(new RegExp(searchTerm, 'gi'), match => `<span style="font-weight: 500;">${match}</span>`);
						option.innerHTML = option.innerHTML.replace(optionText, highlightedText);
						option.style.display = 'block';
					} else {
						option.style.display = 'none';
					}
				});

				if (removeFilter.classList.contains('active')) {
					input.value = '';
					removeFilter.classList.remove('active');

					options.forEach(function (option) {
						option.style.display = 'block';
					});

					if (input.classList.contains('mj-form__filter-location')) {
						updateDirectoryList('location', '');
					}

					if (input.classList.contains('mj-form__filter-event-type')) {
						updateDirectoryList('event_type', '');
					}

					if (input.classList.contains('mj-form__filter-occasion')) {
						updateDirectoryList('occasion', '');
					}

					if (input.classList.contains('mj-form__filter-category')) {
						updateDirectoryList('category', '');
					}
				}

				if (!isActive || !panel.classList.contains('active') || isInputClicked) {
					panel.classList.add('active');
					isActive = true;
				}
			});

			input.addEventListener('click', function () {
				isInputClicked = true; // Set input click state
			});

		}
	}
}




// Initialize for location filter
//initializeFilter('location-filter', 'mj-form__filter-location', 'mj-form__filter-location-panel', 'mj-filter__location-list', 'remove-filter__location');

// Initialize for event type filter
initializeFilter('event-filter', 'mj-form__filter-event-type', 'mj-form__filter-events-panel', 'mj-filter__events-list', 'remove-filter__event-type');

// Initialize for occasion filter
initializeFilter('occasion-filter', 'mj-form__filter-occasion', 'mj-form__filter-occasions-panel', 'mj-filter__occasions-list', 'remove-filter__occasion');


const rangeSlider = document.getElementById('rangeSlider');
const progressNumber = document.getElementById('progressNumber');

if (rangeSlider && progressNumber) {
	// Add an event listener to the range slider
	rangeSlider.addEventListener('input', updateProgress);
}


function updateProgress() {
	const value = rangeSlider.value;
	const newPosition = (value / (rangeSlider.max - rangeSlider.min)) * 100;

	// Update the position of progressNumber
	progressNumber.style.left = `calc(${newPosition}% - 23px)`;

	// Update the text content of progressNumber
	progressNumber.textContent = value;
}


jQuery(document).ready(function ($) {

	var appliedFilters = {};

	// Event listener for clicking on mj-filter__events-list option
	$('.mj-filter__events-list').on('click', 'option', function () {
		var selectedVenueTypeName = $(this).text();
		updateDirectoryList('event_type', selectedVenueTypeName);
	});

	// Event listener for clicking on mj-filter__events-list option
	$('.mj-filter__occasions-list').on('click', 'option', function () {
		var selectedVenueTypeName = $(this).text();
		updateDirectoryList('occasion', selectedVenueTypeName);
	});

	// Event listener for clicking on mj-filter__location-list option
	$('.mj-filter__location-list').on('click', 'option', function () {
		var selectedLocationName = $(this).text();
		updateDirectoryList('location', selectedLocationName);
	});

	// Event listener for clicking on remove-filter__venue-type
	$('.remove-filter__venue-type').on('click', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		}
		removeFilter('event_type');
	});

	// Event listener for clicking on remove-filter__venue-type
	$('.remove-filter__occasion').on('click', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		}
		removeFilter('occasion');
	});

	// Event listener for clicking on remove-filter__location
	$('.remove-filter__location').on('click', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		}
		removeFilter('location');
	});

	// Function to remove filter
	function removeFilter(filterType) {
		// Clear the input and remove the related query parameter from the URL
		$('input[name="mj-form__filter-' + filterType + '"]').val('');
		delete appliedFilters[filterType];

		// Request AJAX again with the new query condition
		updateDirectoryList(filterType, '');
	}


	function updateDirectoryList(filterType, filterValue) {
		// Show loading spinner before the AJAX request
		$('.mj-directory-listing').html('<div class="loading-spinner">Loading...</div>');

		// Update the appliedFilters object
		if (filterValue == '') {
			delete appliedFilters[filterType];
		} else {
			appliedFilters[filterType] = filterValue;
		}

		var data = {
			action: 'update_directory_list',
			nonce: missjones_data.nonce,
			filters: appliedFilters
		};

		// Make the ajax request
		$.ajax({
			url: missjones_data.ajax_url,
			type: 'post',
			data: data,
			beforeSend: function () {
				// Show loading spinner before the AJAX request
				$('.mj-directory-listing').addClass('loading');
				$('.mj-directory-listing').html('<div class="loading-spinner__container"><div class="loading-spinner"></div></div>');
			},
			success: function (response) {
				// Update the directory list with the new content
				//$('.mj-directory-listing').html('<div class="loading-spinner__container"><div class="loading-spinner"></div></div>');

				$('.mj-directory-listing').html(response);

				// Update the URL parameters
				updateUrlParams(appliedFilters);
			},
			complete: function () {
				// Hide loading spinner after the AJAX request is complete
				$('.mj-directory-listing').removeClass('loading');
				$('.loading-spinner__container').remove();
			}
		});
	}

	// Function to update URL parameters
	function updateUrlParams(filters) {
		var queryString = Object.keys(filters).map(function (key) {
			return filters[key] !== '' ? key + '=' + encodeURIComponent(filters[key]) : '';
		}).filter(Boolean).join('&');

		// Build the new URL
		var newUrl = queryString ? window.location.href.split('?')[0] + '?' + queryString : window.location.href.split('?')[0];

		window.history.pushState({ path: newUrl }, '', newUrl);
	}

});



// Check if the element with ID "mj-searchbar__submit" exists
if (document.getElementById("mj-venue_searchbar__submit")) {
	// Add event listener only if the element exists
	document.getElementById("mj-venue_searchbar__submit").addEventListener("click", function () {
		// Get query parameters from the current URL
		const urlParams = new URLSearchParams(window.location.search);

		// Check if event_type parameter exists
		if (urlParams.has('occasion')) {
			var occasion = urlParams.get('occasion');
		}

		// Check if location parameter exists
		if (urlParams.has('location')) {
			var location = urlParams.get('location');
		}

		// Build the new URL with the extracted query parameters
		var newUrl = "/venues-directory";

		if (occasion) {
			newUrl += "?occasion=" + occasion;
			if (location) {
				newUrl += "&location=" + location;
			}
		} else if (location) {
			newUrl += "?location=" + location;
		}

		// Redirect to the new URL
		window.location.href = newUrl;
	});
}

// Check if the element with ID "mj-searchbar__submit" exists
if (document.getElementById("mj-supplier_searchbar__submit")) {
	// Add event listener only if the element exists
	document.getElementById("mj-supplier_searchbar__submit").addEventListener("click", function () {
		// Get query parameters from the current URL
		const urlParams = new URLSearchParams(window.location.search);

		// Check if event_type parameter exists
		if (urlParams.has('event_type')) {
			var event = urlParams.get('event_type');
		}

		// Check if location parameter exists
		if (urlParams.has('location')) {
			var location = urlParams.get('location');
		}

		// Build the new URL with the extracted query parameters
		var newUrl = "/suppliers-directory";

		if (event) {
			newUrl += "?event_type=" + event;
			if (location) {
				newUrl += "&location=" + location;
			}
		} else if (location) {
			newUrl += "?location=" + location;
		}

		// Redirect to the new URL
		window.location.href = newUrl;
	});
}


// document.addEventListener('DOMContentLoaded', function () {
// 	var applyGuestFilter = document.querySelector('#apply-guest-filter');

// 	if (applyGuestFilter) {
// 		applyGuestFilter.addEventListener('click', function (event) {
// 			event.preventDefault();

// 			const urlParams = new URLSearchParams(window.location.search);

// 			// Get the values from input fields
// 			var minSeating = document.querySelector('.mj-form__filter-min-seating').value;
// 			var maxSeating = document.querySelector('.mj-form__filter-max-seating').value;
// 			var minStanding = document.querySelector('.mj-form__filter-min-standing').value;
// 			var maxStanding = document.querySelector('.mj-form__filter-max-standing').value;
// 			var layouts = document.querySelector('#available_layouts').value;

// 			// Update URL parameters if the values are valid
// 			if (minSeating && minSeating >= 0) {
// 				urlParams.set('min_seating', minSeating);
// 			} else {
// 				urlParams.delete('min_seating');
// 			}

// 			if (maxSeating && maxSeating >= 0) {
// 				urlParams.set('max_seating', maxSeating);
// 			} else {
// 				urlParams.delete('max_seating');
// 			}

// 			if (minStanding && minStanding >= 0) {
// 				urlParams.set('min_standing', minStanding);
// 			} else {
// 				urlParams.delete('min_standing');
// 			}

// 			if (maxStanding && maxStanding >= 0) {
// 				urlParams.set('max_standing', maxStanding);
// 			} else {
// 				urlParams.delete('max_standing');
// 			}

// 			if (layouts) {
// 				urlParams.set('layouts', layouts);
// 			} else {
// 				urlParams.delete('layouts');
// 			}

// 			// Build the new URL with the updated parameters
// 			var newUrl = "/venues-directory?" + urlParams.toString();

// 			// Redirect to the new URL
// 			window.location.href = newUrl;
// 		});
// 	}
// });

// document.addEventListener('DOMContentLoaded', function () {
// 	// Get the container element
// 	var btnsContainer = document.querySelector('.mj-guests__btns');
// 	// Get the hidden input element
// 	var hiddenInput = document.querySelector('#available_layouts');

// 	if (btnsContainer) {
// 		// Add click event listener to the container
// 		btnsContainer.addEventListener('click', function (event) {
// 			// Check if the clicked element or its parent is a mj-guests__btn
// 			var btn = event.target.closest('.mj-guests__btn');
// 			if (btn) {
// 				// Toggle the --active class for the clicked element
// 				btn.classList.toggle('--active');
// 				// Get the data-layout attribute value
// 				var layout = btn.getAttribute('data-layout');
// 				// Get the current value of hidden input
// 				var currentValue = hiddenInput.value;
// 				// Check if the layout is already present in the hidden input value
// 				var layoutIndex = currentValue.indexOf(layout);


// 				var hiddenFiltersInput = jQuery('.missjones-widget-applied-filters');
// 				var selectedType = 'layouts';

// 				updateFilterParameters(selectedType, layout, hiddenFiltersInput, true);
// 				updateQueryFilterParameters(selectedType, layout, true);

// 				if (layoutIndex !== -1) {
// 					// Layout is present, remove it if --active is toggled off
// 					if (!btn.classList.contains('--active')) {
// 						var newValue = currentValue.replace(layout + ',', '').replace(',' + layout, '').replace(layout, '');
// 						hiddenInput.value = newValue;
// 					}
// 				} else {
// 					// Layout is not present, add it if --active is toggled on
// 					if (btn.classList.contains('--active')) {
// 						hiddenInput.value += (hiddenInput.value ? ',' : '') + layout;
// 					}
// 				}
// 			}
// 		});
// 	}
// });

document.addEventListener('DOMContentLoaded', function () {
	// Get the container element
	var btnsContainer = document.querySelector('.mj-guests__btns');
	// Get the hidden input element
	var hiddenInput = document.querySelector('#available_layouts');

	if (btnsContainer) {
		// Add click event listener to the container
		btnsContainer.addEventListener('click', function (event) {
			// Check if the clicked element or its parent is a mj-guests__btn
			var btn = event.target.closest('.mj-guests__btn');
			if (btn) {
				// Get the data-layout attribute value
				var layout = btn.getAttribute('data-layout');
				// Get the current value of hidden input
				var currentValue = hiddenInput.value;

				// Check if the button is already active
				var isActive = btn.classList.contains('--active');

				// Remove the --active class from all buttons (to deactivate all other buttons)
				var allBtns = btnsContainer.querySelectorAll('.mj-guests__btn');
				allBtns.forEach(function (b) {
					b.classList.remove('--active');
				});

				// If the clicked button was already active, deactivate it (i.e., no selection)
				if (isActive) {
					layout = '';
					hiddenInput.value = layout; // Clear the hidden input
				} else {
					// Activate the clicked button
					btn.classList.add('--active');
					hiddenInput.value = layout; // Set the hidden input to the selected layout
				}

				// Update filter parameters as needed (assumed existing functionality)
				var hiddenFiltersInput = jQuery('.missjones-widget-applied-filters');
				var selectedType = 'layouts';
				updateFilterParameters(selectedType, layout, hiddenFiltersInput, false); // toggle state based on activation
				updateQueryFilterParameters(selectedType, layout, false); // toggle state based on activation
			}
		});
	}
});


jQuery(document).ready(function () {
	$('#mj-form__search').on('input', function () {
		var searchQuery = $(this).val();
		var dataType = $(this).attr('data-type');

		if (searchQuery.length > 2) {
			$.ajax({
				url: missjones_data.ajax_url,
				type: 'POST',
				cache: false,
				data: {
					action: 'searchbar_results',
					nonce: missjones_data.nonce, // Sending the nonce for security
					searchQuery: searchQuery,
					dataType: dataType
				},
				success: function (response) {
					// Check if the AJAX call was successful
					// if (response.success) {
					if (true) {
						// Clear previous results
						if (response.length > 0) {
							$('#mj-form__filter-search-results').empty();
							$('#mj-form__filter-search-results').addClass('active');
							$('#mj-form__filter-search-results').html(response);
						}

					} else {
						// Handle failure
						$('#mj-form__filter-search-results').html('<p>No results found.</p>');
					}
				},
				error: function () {
					// Handle errors here
					$('#mj-form__filter-search-results').html('<p>Error fetching results.</p>');
				}
			});
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const searchbarControls = document.querySelectorAll('.mj-searchbar__controls-item');
	const searchbarWrappers = document.querySelectorAll('.mj-searchbar__wrapper');

	searchbarControls.forEach(control => {
		control.addEventListener('click', function () {
			// Remove --active class from all searchbar controls
			searchbarControls.forEach(item => {
				item.classList.remove('--active');
			});

			// Add --active class to the clicked searchbar control
			this.classList.add('--active');

			// Get the data-target value from the clicked element
			const dataTarget = this.getAttribute('data-target');
			const dataType = this.getAttribute('data-type');

			jQuery("#missjones-widget-search-value-type").val(dataType);

			// Remove --active class from all searchbar wrappers
			searchbarWrappers.forEach(wrapper => {
				wrapper.classList.remove('--active');
			});

			// Add --active class to the searchbar wrapper with id equal to data-target value
			const targetWrapper = document.getElementById(dataTarget);
			if (targetWrapper) {
				targetWrapper.classList.add('--active');
			}
		});
	});
});

jQuery(document).ready(function () {
	var suggestedResultsClass = '.missjones-widget-filter__suggested-results-container';
	var $input = jQuery('.missjones-widget-filter__input');
	var $suggestedList = jQuery('.missjones-widget-filter__suggested-list');
	var $newList = jQuery('.missjones-widget-filter__suggested-list-container.--new-list');

	// Focus event on input
	$input.focus(function () {
		jQuery(suggestedResultsClass).removeClass('--opened');
		var dataType = jQuery(this).data('type');
		var suggestedResults = jQuery(suggestedResultsClass + '[data-type="' + dataType + '"]');
		suggestedResults.addClass('--opened');
	});

	// Click outside of input and suggested results
	jQuery(document).click(function (event) {
		if (!jQuery(event.target).closest('.missjones-widget-filter__input').length &&
			!jQuery(event.target).closest(suggestedResultsClass).length) {
			jQuery(suggestedResultsClass).removeClass('--opened');
		}
	});

	// Input event for filtering the list
	$input.on('input', function () {

		var filterInput = jQuery(this);
		var filterVal = jQuery(this).val();
		var filterText = filterVal.toLowerCase();

		if (filterVal.length) {
			filterInput.addClass('--active');
		} else {
			filterInput.removeClass('--active');
		}

		var selectedType = filterInput.data('type');
		var hiddenFiltersInput = jQuery('.missjones-widget-applied-filters');

		updateFilterParameters(selectedType, filterText, hiddenFiltersInput);
		updateQueryFilterParameters(selectedType, filterText);

		if (filterText) {
			$suggestedList.addClass('--opened');
			$newList.removeClass('--opened');
			var hasMatch = false;
			$suggestedList.find('li').each(function () {
				var itemText = jQuery(this).text().toLowerCase();
				if (itemText.includes(filterText)) {
					jQuery(this).show();
					hasMatch = true;
				} else {
					jQuery(this).hide();
				}
			});

			if (!hasMatch) {
				// Callback text if no matches are found
				$suggestedList.append('<li class="no-match">No matches found</li>');
			} else {
				$suggestedList.find('.no-match').remove();
			}
		} else {
			$suggestedList.removeClass('--opened');
			$suggestedList.find('li').show();
			$suggestedList.find('.no-match').remove();
		}
	});

	// Blur event to hide suggested list
	$input.on('blur', function () {
		setTimeout(function () {
			$suggestedList.removeClass('--opened');
			$suggestedList.find('li').show();
			$newList.addClass('--opened');
		}, 200); // Delay to allow click event on suggestions
	});

	// Click event outside of input and lists to close suggestions
	jQuery(document).on('click', function (event) {
		if (!jQuery(event.target).closest('.missjones-widget-filter__input, .missjones-widget-filter__suggested-list').length) {
			$suggestedList.removeClass('--opened');
			$suggestedList.find('li').show();
			$newList.addClass('--opened');
		}
	});

	// Click event on list item to select and update input
	$suggestedList.on('click', '.missjones-widget-filter__suggested-list-item', function () {
		var selectedItem = jQuery(this);

		var selectedType = selectedItem.closest('.missjones-widget-filter__suggested-results-container').data('type');
		// var selectedInput = jQuery('.missjones-widget-filter__input.--' + selectedType);
		var selectedInput = jQuery('.missjones-widget-filter__input' + '[data-type="' + selectedType + '"]');

		jQuery(suggestedResultsClass).removeClass('--opened');
		var selectedItemText = selectedItem.text();
		var selectedItemId = selectedItem.data('id');

		// Update the input with the selected item's text
		selectedInput.val(selectedItemText);

		var hiddenInputSelector = jQuery('.missjones-widget-applied-filters');

		updateFilterParameters(selectedType, selectedItemText, hiddenInputSelector);
		updateQueryFilterParameters(selectedType, selectedItemText);
		applyQueryParamsFilter();

		// Close the suggestion window
		$suggestedList.removeClass('--opened');
	});
});


jQuery(document).ready(function () {
	jQuery('.missjones-widget-filter__submit').click(function (event) {
		event.preventDefault();
		console.log(event);
		applyQueryParamsFilter(1, true);
	});
});

// Function to slugify a string
function slugify(text) {
	return text.toString().toLowerCase()
		.replace(/\s+/g, '-')           // Replace spaces with -
		.replace(/[^\w\-]+/g, '')       // Remove all non-word chars
		.replace(/\-\-+/g, '-')         // Replace multiple - with single -
		.replace(/^-+/, '')             // Trim - from start of text
		.replace(/-+$/, '');            // Trim - from end of text
}

function reloadFilteredResults(options = {}) {
	const { filters, defaultFilters, filtersSettings } = options;

	const appliedFiltersString = filters || $('#missjones-widget-applied-filters').val();
	const defaultFiltersString = defaultFilters || $('#missjones-widget-default-filters').val();
	const filterSettingsString = filtersSettings || $('#missjones-widget-filters-settings').val();

	// Build the filters object based on provided options
	const appliedFilters = {
		filters: appliedFiltersString,
		defaultFilters: JSON.parse(defaultFiltersString),
		filtersSettings: JSON.parse(filterSettingsString)
	};

	// Prepare data for AJAX request
	const data = {
		action: 'reload_filtered_results_widget',
		nonce: missjones_data.nonce,
		filters: appliedFilters
	};

	// Make the AJAX request
	$.ajax({
		url: missjones_data.ajax_url,
		type: 'post',
		data: data,
		beforeSend: function () {
			// Show loading spinner before the AJAX request
			$('.missjones-filter-posts-widget__wrapper').addClass('-inactive');
		},
		success: function (response) {
			// Update the widget content with the new response
			$('.missjones-filter-posts-widget__wrapper').html(response);

			// Re-initialize Swiper for each new .venue-swiper-carousel found in the response
			$('.missjones-filter-posts-widget__wrapper .venue-swiper-carousel').each(function () {
				new Swiper(this, {
					slidesPerView: 1,
					spaceBetween: 0,
					freeMode: false,
					loop: false,
					loadPrevNext: true,
					navigation: {
						nextEl: $(this).find(".swiper-button-next")[0],
						prevEl: $(this).find(".swiper-button-prev")[0],
					},
				});
			});

			jQuery('html, body').animate({ scrollTop: 0 }, 'slow');

			// var venueItemSwiper = new Swiper(".venue-swiper-carousel", {
			// 	slidesPerView: 1,
			// 	spaceBetween: 10,
			// 	freeMode: false,
			// 	loop: false,
			// });

		},
		complete: function () {
			// Hide loading spinner after the AJAX request is complete
			$('.missjones-filter-posts-widget__wrapper').removeClass('-inactive');
			$('.loading-spinner__container').remove();
		}
	});
}


jQuery(document).ready(function () {
	const widgetWrapperClass = '.missjones-filter-posts-widget__wrapper';

	if (!jQuery(widgetWrapperClass).length) return;

	applyQueryParamsFilter();
});

jQuery(document).ready(function () {
	const filterBar = '.mj-filters-bar__container';

	if (!jQuery(filterBar).length) return;

	restoreFilterBarValues();
});

function restoreFilterBarValues() {
	// const filterElement = document.getElementById('missjones-widget-applied-filters');
	// if (!filterElement) return;  // Exit if the filter element doesn't exist

	const filtersObj = getQueryParams();

	const filters = JSON.stringify(filtersObj);

	// const filters = filterElement.value;
	if (!filtersObj || Object.keys(filtersObj).length == 0) return;  // Exit if filters are undefined or empty

	// Restore Occasion Filter
	const categoryFilter = jQuery('.mj-form__filter-category');
	if (categoryFilter.length) {
		const filterName = 'category';
		const filterValue = exportFilterValueFromJsonString(filters, filterName);
		categoryFilter.val(filterValue);
		if (typeof filterValue == 'string' && filterValue.length) {
			categoryFilter.addClass('--active');
		}
	}

	// Restore Occasion Filter
	const occasionFilter = jQuery('.mj-form__filter-occasion');
	if (occasionFilter.length) {
		const filterName = 'occasion';
		const filterValue = exportFilterValueFromJsonString(filters, filterName);
		occasionFilter.val(filterValue);
		if (typeof filterValue == 'string' && filterValue.length) {
			occasionFilter.addClass('--active');
		}
	}

	// Restore Location Filter
	const locationFilter = jQuery('.mj-form__filter-location');
	if (locationFilter.length) {
		const filterName = 'location';
		const filterValue = exportFilterValueFromJsonString(filters, filterName);
		locationFilter.val(filterValue);
		if (typeof filterValue == 'string' && filterValue.length) {
			locationFilter.addClass('--active');
		}
	}

	// Restore Max Guests Filter
	const maxGuestFilter = jQuery('.mj-form__filter-max-guest');
	if (maxGuestFilter.length) {
		const filterName = 'max-guests';
		const filterValue = exportFilterValueFromJsonString(filters, filterName);
		maxGuestFilter.val(filterValue);
	}

	// Restore Max Guests Filter
	const layoutsFilter = jQuery('.mj-form__filter-layouts');
	if (layoutsFilter.length) {
		const filterName = 'layouts';
		const filterValue = exportFilterValueFromJsonString(filters, filterName, false);
		if (filterValue) {
			const layoutArray = filterValue.split(',');  // Convert string to array

			layoutArray.forEach(layoutType => {
				// alert(layoutType);
				layoutsFilter.find('.mj-guests__btn').each(function () {
					const $btn = jQuery(this);
					const dataLayout = $btn.data('layout');

					if (dataLayout === layoutType) {
						$btn.addClass('--active');
					}
				});
			});
		};
	}

	// Restore Max guests Active
	const guestsFilterBtn = jQuery('#mj-form__filter-guests-btn');
	if (guestsFilterBtn.length) {
		const maxGuestFilter = jQuery('#mj-form__filter-max-guest'); // Assuming maxGuestFilter is a jQuery object
		if (maxGuestFilter.val() > 0) {
			guestsFilterBtn.addClass('--active');
			maxGuestFilter.addClass('--active');
		}

		// Loop through items under .mj-form__filter-layouts which are .mj-guests__btn
		var guestBtns = document.querySelectorAll('.mj-form__filter-layouts .mj-guests__btn');
		guestBtns.forEach(function (guestBtn) {
			// Remove --active class from each of them if they have it.
			if (guestBtn.classList.contains('--active')) {
				guestsFilterBtn.addClass('--active');
			}
		});
	}

	// Restore Remove Filter
	const removeFilter = jQuery('#mj-form__filter-remove');
	if (removeFilter.length) {
		removeFilter.addClass('--active');
	}
}

function exportFilterValueFromJsonString(inputString, key, unslugify = true) {
	// Parse the string into an object
	let obj = JSON.parse(inputString);

	// Check if 'occasion' key exists
	if (obj.hasOwnProperty(key)) {
		// Get the 'occasion' value
		let indexValue = obj[key];

		// Capitalize the first letter of each word
		if (unslugify) {
			// Replace hyphens with spaces
			indexValue = indexValue.replace(/-/g, ' ');
			indexValue = indexValue.replace(/\b\w/g, char => char.toUpperCase());
		}

		return indexValue;
	}
}

jQuery(document).ready(function ($) {
	// Use event delegation for dynamically loaded content
	$(document).on('click', '.missjones-pagination a', function (e) {
		e.preventDefault();

		var matchResult = $(this).data('page').match(/paged=(\d+)/);
		var clickedPage = matchResult ? matchResult[1] : 1;
		updateFilterParameters('page', clickedPage, '#missjones-widget-filters-settings');
		applyQueryParamsFilter(clickedPage);
	});
});

// Function to parse query parameters
function getQueryParams() {
	var params = {};
	var queryString = window.location.search.substring(1);
	var regex = /([^&=]+)=([^&]*)/g;
	var m;

	while (m = regex.exec(queryString)) {
		params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
	}

	return params;
}

function updateFilterParameters(selectedType, selectedItemText, hiddenInputSelector, array = false) {

	// Create a slug for the selected item text
	var selectedSlug = slugify(selectedItemText);

	// Get the current value of the hidden input
	var $hiddenInput = jQuery(hiddenInputSelector);
	var currentValue = $hiddenInput.val();


	// Initialize an object to hold the JSON items
	var currentObject = {};

	// If there is a current value and it's a valid JSON string, parse it
	if (currentValue) {
		try {
			currentObject = JSON.parse(currentValue);
			if (typeof currentObject !== 'object' || currentObject === null) {
				currentObject = {};
			}
		} catch (e) {
			console.error('Invalid JSON in hidden input value:', e);
		}
	}

	// Check if the array option is enabled
	if (array) {
		// Check if the selected type already exists in the object
		if (currentObject[selectedType]) {

			// If it exists, ensure it is an array
			if (!Array.isArray(currentObject[selectedType])) {
				currentObject[selectedType] = currentObject[selectedType].split(',');
			}

			// Check if the selected item is already in the array
			var itemIndex = currentObject[selectedType].indexOf(selectedSlug);

			if (itemIndex !== -1) {
				// If it exists, remove it
				currentObject[selectedType].splice(itemIndex, 1);
			} else {
				// If it doesn't exist, add it
				currentObject[selectedType].push(selectedSlug);
			}

			// If the array becomes empty, remove the key
			if (currentObject[selectedType].length === 0) {
				delete currentObject[selectedType];
			}
		} else {
			// If the selected type doesn't exist, add the new item as an array
			currentObject[selectedType] = [selectedSlug];
		}
	} else {
		// If array option is not enabled, simply replace the existing filter
		currentObject[selectedType] = selectedSlug;
	}

	// Convert the updated object back to a JSON string
	var jsonString = JSON.stringify(currentObject);

	// Update the hidden input with the new JSON string
	$hiddenInput.val(jsonString);
}


function updateQueryFilterParameters(selectedType, selectedItemText, array = false) {
	// Create a slug for the selected item text
	var selectedSlug = slugify(selectedItemText);

	// Get the current URL and its search parameters
	var url = new URL(window.location);
	var params = new URLSearchParams(url.search);

	// Initialize an object to hold the query parameters
	let filters = Object.fromEntries(params.entries());

	// Create the new filter key
	var newFilterKey = `${selectedType}`;

	// Check if the array option is enabled
	if (array) {
		// Check if the filter key already exists in the params
		if (filters[newFilterKey]) {
			// Split the existing values into an array
			var existingValues = filters[newFilterKey].split(',');

			// Check if the selected item is already in the array
			var itemIndex = existingValues.indexOf(selectedSlug);

			if (itemIndex !== -1) {
				// If it exists, remove it
				existingValues.splice(itemIndex, 1);
			} else {
				// If it doesn't exist, add it
				existingValues.push(selectedSlug);
			}

			// Update or remove the filter key based on the array length
			if (existingValues.length > 0) {
				filters[newFilterKey] = existingValues.join(',');
			} else {
				delete filters[newFilterKey]; // Remove the key if array is empty
			}
		} else {
			// If the filter key doesn't exist, just add the new item
			filters[newFilterKey] = selectedSlug;
		}
	} else {
		// If array option is not enabled, simply replace the existing filter
		if (selectedSlug) {
			filters[newFilterKey] = selectedSlug;
		} else {
			delete filters[newFilterKey]; // Remove the key if the value is empty
		}
	}

	// Clear existing type-* query parameters
	for (const key of Object.keys(filters)) {
		if (key.startsWith('type-') && filters[key] === undefined) {
			delete filters[key]; // Use delete operator to remove the key
		}
	}

	// Reconstruct the URLSearchParams object with updated filters
	const newParams = new URLSearchParams(filters);

	// Update the URL with the new query parameters
	url.search = newParams.toString();
	window.history.replaceState(null, '', url.toString());

	// Restore Remove Filter
	const removeFilter = jQuery('#mj-form__filter-remove');
	if (removeFilter.length) {
		if (newParams.has('layouts') || newParams.has('max-guests') || newParams.has('occasion') || newParams.has('location')) {
			if (newParams.has('occasion')) {
				jQuery('#mj-form__filter-occasion').addClass('--active');
			}
			if (newParams.has('location')) {
				jQuery('#mj-form__filter-location').addClass('--active');
			}
			removeFilter.addClass('--active');
		} else {
			removeFilter.removeClass('--active');
		}
	}

	const guestsFilterBtn = jQuery('#mj-form__filter-guests-btn');
	if (guestsFilterBtn.length) {
		if (newParams.has('layouts') || newParams.has('max-guests')) {
			guestsFilterBtn.addClass('--active');
		} else {
			guestsFilterBtn.removeClass('--active');
		}
	}
}

function applyQueryParamsFilter(page = 1, redirect = false) {
	const queryParams = getQueryParams();

	updateFilterParameters('page', page, '#missjones-widget-filters-settings');

	console.log('here');
	let filterType = $('#missjones-widget-filter-value-type').val();
	let searchType = $('#missjones-widget-search-value-type').val();

	if (filterType) {
		queryParams.type = filterType;
		const filterParams = {
			type: jQuery('#missjones-widget-filter-value-type').val(),
			page: page,
			filters: queryParams,
		};
		reloadFilteredResults(filterParams);
	}

	if (searchType) {
		// Get the value of searchType
		var type = searchType;

		var queryParameters = window.location.search;

		// Get the main domain (site URL)
		var site_url = window.location.origin;
		var site_url = site_url_wpml();

		if (redirect) {
			// Redirect based on the type
			if (type === 'venue') {
				window.location.href = site_url + 'venues-directory/' + queryParameters;
			} else if (type === 'supplier') {
				window.location.href = site_url + 'suppliers-directory/' + queryParameters;
			}
		}
	}
}

var guestFilterButton = document.getElementById('apply-guest-filter');
if (guestFilterButton) {
	guestFilterButton.addEventListener('click', function (event) {
		event.preventDefault();
		updateFilterParameters('page', 1, '#missjones-widget-filters-settings');
		applyQueryParamsFilter();

		// Assuming 'expandableButton' is already defined
		var panels = document.querySelectorAll('.mj-form__filter-panel');

		// Iterate through each panel and remove the 'active' class
		panels.forEach(function (panel) {
			panel.classList.remove('active');
		});
	});
}
document.addEventListener('DOMContentLoaded', function () {
	// Get the parent element that will always be present
	var container = document.body; // or another parent element that exists on page load

	// Add a click event listener to the parent element
	container.addEventListener('click', function (event) {
		// Check if the clicked element has the class 'enquiry-popup'
		if (event.target && event.target.classList.contains('enquiry-popup')) {
			// Get the data-id attribute from the clicked element
			var dataId = event.target.getAttribute('data-id');
			var dataPostName = event.target.getAttribute('data-post-name');

			// Set the value of #mj-form__enquire-post to the dataId
			var enquiryPost = document.getElementById('mj-form__enquire-post');
			var enquiryPostTitleWrapper = document.getElementById('enquiry-items');

			if (enquiryPost) {
				enquiryPost.value = dataId;
				enquiryPostTitleWrapper.textContent = dataPostName;
			}
		}
	});
});

